import IndustriesSelect from './IndustriesSelect';

export { GET_INDUSTRIES_URL } from './IndustriesSelect/constants';
export { rawIndustriesFixture, industriesValuesFixture } from '../mocks/fixtures';
export default IndustriesSelect;
